import { useEffect } from 'react'

export const useOuterClickListener =
  /**
   *
   * @param {import('./outer-click-listener.d.ts').UseOuterClickListenerProps} args
   */
  args => {
    const { ref, listen = false, onClick, onKeyDown } = args || {}
    useEffect(() => {
      if (listen) {
        const click = event => {
          if (listen && ref && ref.current && onClick) {
            const element = ref.current.contains
              ? ref.current
              : ref.current.getElement
              ? ref.current.getElement()
              : null
            if (element && !element.contains(event.target)) {
              onClick(event)
            }
          }
        }
        const keyDown = event => {
          if (listen && onKeyDown) {
            onKeyDown(event)
          }
        }
        if (onClick) document.addEventListener('click', click)
        if (onKeyDown) document.addEventListener('keydown', keyDown)
        return () => {
          if (onClick) document.removeEventListener('click', click)
          if (onKeyDown) document.removeEventListener('keydown', keyDown)
        }
      } else return () => {}
    }, [listen, ref, onClick, onKeyDown])
  }

export default useOuterClickListener
